import {
    ProductType,
} from 'app/enums/label.enums'
import {
    ContainerStatusBreakdownType,
} from 'app/Apps/ContainerManagement/ServiceCenters/ScenarioEditor/ScenarioEditor.types'
import {
    SkyDataGridColumnDefinition,
} from 'app/PoC/DataGridDemoPages/components/SkyBaseDataGrid'

const columns: SkyDataGridColumnDefinition<ContainerStatusBreakdownType>[] = [
    {
        name: 'productType',
        labelKey: 'PRODUCT_TYPE',
        componentName: 'EnumValue',
        allowedValuesEnum: ProductType,
        sorting: false,
    },
    {
        name: 'preconditioning',
        labelKey: 'PRE-CONDITIONING',
        sorting: false,
    },
    {
        name: 'checkPreconditioning',
        labelKey: 'CHECK_PRE-CONDITIONING',
        sorting: false,
    },
    {
        name: 'preconditioned',
        labelKey: 'PRE-CONDITIONED',
        sorting: false,
    },
    {
        name: 'qcPassed',
        labelKey: 'QC_PASSED',
        sorting: false,
    },
    {
        name: 'qcPassedAutomated',
        labelKey: 'QC_PASSED_AUTOMATED',
        sorting: false,
    },
    {
        name: 'toBeMaintained',
        labelKey: 'TO_BE_MAINTAINED',
        sorting: false,
    },
]

export default columns
